import * as React from "react";
import { SVGProps } from "react";
const SvgComponent = ({ fill, ...props }: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={fill || "currentColor"}
      fillRule="evenodd"
      d="M13.59 4.278a1 1 0 0 1 1.414.03l6.717 7a1 1 0 0 1 0 1.384l-6.717 7a1 1 0 0 1-1.443-1.384l5.063-5.276H4a1 1 0 1 1 0-2h14.685l-5.124-5.34a1 1 0 0 1 .03-1.414Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgComponent;
